var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 181 59",
    enableBackground: "new 0 0 181 59",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.8,17.9h3.8c1.1,0,1.9,0.3,2.5,0.8C59.7,19.3,60,20,60,21c0,1-0.3,1.7-0.9,2.2c-0.6,0.5-1.4,0.8-2.5,0.8h-2.3v3.7h-1.4 V17.9z M56.4,22.8c0.7,0,1.2-0.1,1.6-0.4c0.4-0.3,0.6-0.7,0.6-1.4s-0.2-1.1-0.6-1.4c-0.4-0.3-0.9-0.4-1.6-0.4h-2.2v3.7H56.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2,21h1.4v1.2c0.3-0.4,0.7-0.7,1.2-0.9c0.5-0.2,1.1-0.3,1.8-0.3v1.1c-0.7,0-1.3,0.1-1.8,0.3c-0.5,0.2-0.9,0.6-1.1,1.1 v4.2h-1.4V21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2,27.5c-0.6-0.3-1-0.7-1.3-1.2c-0.3-0.5-0.5-1.2-0.5-1.9c0-0.7,0.2-1.3,0.5-1.9c0.3-0.5,0.8-1,1.3-1.3 c0.6-0.3,1.2-0.4,2-0.4c0.8,0,1.4,0.1,2,0.4c0.6,0.3,1,0.7,1.4,1.3c0.3,0.5,0.5,1.2,0.5,1.9c0,0.7-0.2,1.4-0.5,1.9 c-0.3,0.5-0.8,0.9-1.4,1.2c-0.6,0.3-1.2,0.4-2,0.4C69.4,27.9,68.7,27.8,68.2,27.5z M71.9,26.1c0.4-0.4,0.6-1,0.6-1.8 c0-0.8-0.2-1.4-0.6-1.8c-0.4-0.4-1-0.7-1.7-0.7s-1.3,0.2-1.7,0.7c-0.4,0.4-0.6,1-0.6,1.8c0,0.7,0.2,1.3,0.6,1.8 c0.4,0.4,1,0.7,1.7,0.7S71.5,26.6,71.9,26.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5,22.1h-1V21h1v-1.3c0-0.8,0.2-1.4,0.7-1.8c0.4-0.4,1-0.6,1.8-0.6c0.4,0,0.7,0.1,1.1,0.2v1.2 c-0.3-0.1-0.5-0.2-0.8-0.2c-0.4,0-0.8,0.1-1,0.3c-0.2,0.2-0.3,0.5-0.3,1V21h1.7v1.1h-1.7v5.6h-1.4V22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8,27c-0.7-0.6-1.1-1.5-1.1-2.6c0-1.1,0.3-2,0.9-2.6c0.6-0.6,1.5-1,2.7-1c0.8,0,1.4,0.1,2,0.4c0.5,0.3,0.9,0.7,1.2,1.2 s0.4,1.1,0.4,1.8v0.7H81c0,0.6,0.3,1.1,0.8,1.4c0.5,0.3,1.2,0.5,2,0.5c0.4,0,0.9,0,1.3-0.1c0.4-0.1,0.8-0.2,1.2-0.3v1.1 c-0.3,0.1-0.7,0.2-1.2,0.3c-0.5,0.1-1,0.1-1.4,0.1C82.4,27.9,81.5,27.6,80.8,27z M85.6,23.9c0-0.6-0.2-1.1-0.6-1.5s-1-0.5-1.7-0.5 c-0.7,0-1.3,0.2-1.7,0.5s-0.6,0.8-0.6,1.5H85.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5,27.8c-0.5-0.1-0.9-0.3-1.2-0.5v-1.2c0.4,0.2,0.8,0.4,1.3,0.5c0.5,0.1,0.9,0.2,1.4,0.2c0.5,0,0.9-0.1,1.1-0.2 c0.2-0.1,0.3-0.3,0.3-0.6c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.2-0.5-0.3c-0.3-0.1-0.6-0.2-1.2-0.4c-0.6-0.2-1-0.3-1.3-0.5 c-0.3-0.2-0.6-0.4-0.7-0.6c-0.2-0.3-0.2-0.6-0.2-1c0-0.6,0.3-1.1,0.8-1.5c0.5-0.3,1.2-0.5,2.1-0.5c0.4,0,0.9,0,1.3,0.1 c0.4,0.1,0.8,0.2,1,0.4v1.2c-0.3-0.2-0.6-0.3-1-0.4c-0.4-0.1-0.8-0.1-1.2-0.1c-0.5,0-0.9,0.1-1.1,0.2c-0.3,0.1-0.4,0.3-0.4,0.6 c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.6,0.2,1.2,0.3c0.8,0.2,1.4,0.5,1.8,0.8s0.5,0.8,0.5,1.3 c0,0.6-0.2,1-0.7,1.4c-0.5,0.3-1.2,0.5-2.1,0.5C90.5,27.9,90,27.9,89.5,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,27.8c-0.5-0.1-0.9-0.3-1.2-0.5v-1.2c0.4,0.2,0.8,0.4,1.3,0.5c0.5,0.1,0.9,0.2,1.4,0.2c0.5,0,0.9-0.1,1.1-0.2 c0.2-0.1,0.3-0.3,0.3-0.6c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.2-0.5-0.3c-0.3-0.1-0.6-0.2-1.2-0.4c-0.6-0.2-1-0.3-1.3-0.5 c-0.3-0.2-0.6-0.4-0.7-0.6c-0.2-0.3-0.2-0.6-0.2-1c0-0.6,0.3-1.1,0.8-1.5c0.5-0.3,1.2-0.5,2.1-0.5c0.4,0,0.9,0,1.3,0.1 c0.4,0.1,0.8,0.2,1,0.4v1.2c-0.3-0.2-0.6-0.3-1-0.4c-0.4-0.1-0.8-0.1-1.2-0.1c-0.5,0-0.9,0.1-1.1,0.2c-0.3,0.1-0.4,0.3-0.4,0.6 c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.6,0.2,1.2,0.3c0.8,0.2,1.4,0.5,1.8,0.8s0.5,0.8,0.5,1.3 c0,0.6-0.2,1-0.7,1.4c-0.5,0.3-1.2,0.5-2.1,0.5C97,27.9,96.5,27.9,96,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.1,19.4c-0.2-0.2-0.2-0.4-0.2-0.6s0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2 c0.2,0.2,0.2,0.4,0.2,0.6s-0.1,0.4-0.2,0.6s-0.4,0.2-0.6,0.2C102.4,19.7,102.2,19.6,102.1,19.4z M101.9,21h1.4v6.7h-1.4V21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.9,27.5c-0.6-0.3-1-0.7-1.3-1.2c-0.3-0.5-0.5-1.2-0.5-1.9c0-0.7,0.2-1.3,0.5-1.9c0.3-0.5,0.8-1,1.3-1.3 c0.6-0.3,1.2-0.4,2-0.4c0.8,0,1.4,0.1,2,0.4c0.6,0.3,1,0.7,1.4,1.3c0.3,0.5,0.5,1.2,0.5,1.9c0,0.7-0.2,1.4-0.5,1.9 c-0.3,0.5-0.8,0.9-1.4,1.2c-0.6,0.3-1.2,0.4-2,0.4C108.1,27.9,107.5,27.8,106.9,27.5z M110.6,26.1c0.4-0.4,0.6-1,0.6-1.8 c0-0.8-0.2-1.4-0.6-1.8c-0.4-0.4-1-0.7-1.7-0.7c-0.7,0-1.3,0.2-1.7,0.7c-0.4,0.4-0.6,1-0.6,1.8c0,0.7,0.2,1.3,0.6,1.8 c0.4,0.4,1,0.7,1.7,0.7C109.6,26.8,110.2,26.6,110.6,26.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.3,21h1.4v1c0.3-0.4,0.7-0.7,1.2-0.9c0.5-0.2,0.9-0.3,1.4-0.3c0.9,0,1.6,0.2,2,0.7c0.4,0.5,0.7,1.1,0.7,1.9v4.3h-1.4 v-4.2c0-1.1-0.5-1.6-1.6-1.6c-0.4,0-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.5-1,1v4.5h-1.4V21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.9,27.3c-0.5-0.4-0.7-1-0.7-1.7c0-0.7,0.2-1.3,0.7-1.7c0.5-0.4,1.1-0.6,2-0.6c0.9,0,1.7,0.2,2.4,0.6v-0.4 c0-0.5-0.2-0.9-0.5-1.2c-0.3-0.3-0.8-0.4-1.5-0.4c-0.4,0-0.8,0-1.2,0.1c-0.4,0.1-0.7,0.2-1,0.3v-1.1c0.3-0.1,0.6-0.2,1.1-0.3 c0.4-0.1,0.9-0.1,1.3-0.1c1.1,0,1.9,0.2,2.5,0.7c0.5,0.5,0.8,1.2,0.8,2v4.2h-1.3V27c-0.3,0.3-0.6,0.6-1,0.7 c-0.4,0.2-0.9,0.2-1.4,0.2C124,27.9,123.4,27.7,122.9,27.3z M126.4,26.6c0.4-0.2,0.6-0.4,0.8-0.7v-0.9c-0.6-0.4-1.3-0.6-2-0.6 c-0.5,0-0.9,0.1-1.2,0.3c-0.3,0.2-0.4,0.5-0.4,1c0,0.8,0.5,1.2,1.6,1.2C125.6,26.9,126.1,26.8,126.4,26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.4,17.4h1.4v10.3h-1.4V17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8,34.7h1.4v9.8h-1.4V34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1,37.8h1.4v1c0.3-0.4,0.7-0.7,1.2-0.9c0.5-0.2,0.9-0.3,1.4-0.3c0.9,0,1.6,0.2,2,0.7c0.4,0.5,0.7,1.1,0.7,1.9v4.3h-1.4 v-4.2c0-1.1-0.5-1.6-1.6-1.6c-0.4,0-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.5-1,1v4.5h-1.4V37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9,44.3c-0.5-0.3-1-0.7-1.3-1.2c-0.3-0.5-0.5-1.2-0.5-1.9c0-0.7,0.2-1.3,0.5-1.9s0.7-1,1.3-1.3 c0.5-0.3,1.1-0.5,1.8-0.5c1.2,0,2.1,0.4,2.8,1.1v-4.5h1.4v10.3h-1.4v-1c-0.4,0.4-0.8,0.7-1.2,0.9s-1,0.3-1.6,0.3 C67,44.7,66.4,44.6,65.9,44.3z M69.5,43.2c0.4-0.3,0.7-0.7,0.9-1.2v-1.5c-0.2-0.5-0.5-0.9-0.9-1.2c-0.4-0.3-1-0.5-1.5-0.5 c-0.5,0-0.9,0.1-1.2,0.3c-0.4,0.2-0.7,0.5-0.9,0.9s-0.3,0.8-0.3,1.3c0,0.5,0.1,0.9,0.3,1.3s0.5,0.7,0.9,0.9 c0.4,0.2,0.8,0.3,1.2,0.3C68.6,43.6,69.1,43.5,69.5,43.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5,43.8c-0.7-0.6-1.1-1.5-1.1-2.6c0-1.1,0.3-2,0.9-2.6c0.6-0.6,1.5-1,2.7-1c0.8,0,1.4,0.1,2,0.4 c0.5,0.3,0.9,0.7,1.2,1.2c0.3,0.5,0.4,1.1,0.4,1.8v0.7h-5.9c0,0.6,0.3,1.1,0.8,1.4c0.5,0.3,1.2,0.5,2,0.5c0.4,0,0.9,0,1.3-0.1 c0.4-0.1,0.8-0.2,1.2-0.3v1.1c-0.3,0.1-0.7,0.2-1.2,0.3c-0.5,0.1-1,0.1-1.4,0.1C76.1,44.7,75.2,44.4,74.5,43.8z M79.3,40.7 c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.3-1-0.5-1.7-0.5c-0.7,0-1.3,0.2-1.7,0.5c-0.4,0.4-0.6,0.8-0.6,1.5H79.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2,37.8h1.3v1c0.3-0.4,0.7-0.7,1.1-0.9c0.4-0.2,0.8-0.3,1.2-0.3c0.5,0,1,0.1,1.3,0.3s0.6,0.5,0.7,0.8 c0.3-0.4,0.7-0.6,1.1-0.8c0.4-0.2,0.9-0.3,1.3-0.3c0.8,0,1.4,0.2,1.8,0.6c0.4,0.4,0.5,1,0.5,1.8v4.5h-1.4v-4.3 c0-0.6-0.1-0.9-0.3-1.2s-0.6-0.3-1-0.3c-0.7,0-1.3,0.3-1.7,0.9c0,0.1,0,0.4,0,0.7v4.2h-1.4v-4.3c0-0.6-0.1-0.9-0.3-1.2 s-0.5-0.3-1-0.3c-0.7,0-1.3,0.4-1.9,1.2v4.6h-1.4V37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6,36.2c-0.2-0.2-0.2-0.4-0.2-0.6s0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2 c0.2,0.2,0.2,0.4,0.2,0.6s-0.1,0.4-0.2,0.6c-0.2,0.2-0.4,0.2-0.6,0.2C94.9,36.5,94.7,36.4,94.6,36.2z M94.5,37.8h1.4v6.7h-1.4 V37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9,44.1c-0.4-0.4-0.6-0.9-0.6-1.7v-3.6h-1v-1.1h1v-2h1.4v2h1.7v1.1h-1.7v3.5c0,0.4,0.1,0.8,0.3,1s0.5,0.3,0.9,0.3 c0.3,0,0.5-0.1,0.8-0.2v1.1c-0.4,0.1-0.8,0.2-1.3,0.2C99.8,44.7,99.2,44.5,98.9,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.7,47.1V46c0.2,0.1,0.5,0.1,0.9,0.1c0.3,0,0.6-0.1,0.8-0.2c0.2-0.2,0.4-0.4,0.5-0.8l0.3-0.8l-2.9-6.6h1.5l2.2,5.2 l2.1-5.2h1.5l-3,7.5c-0.3,0.7-0.6,1.2-1,1.5c-0.4,0.3-0.9,0.5-1.5,0.5C103.4,47.3,103,47.2,102.7,47.1z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M15.1,36.5l3.1-3.1 c1.9-1.9,4.5-3,7.2-3h6.2c0.8,0,1.3,0.8,0.9,1.5l0,0c-0.8,1.5-2.4,2.4-4.1,2.4h-2.7v1.9h9.8l5.7-5.7c1.1-1.1,3-0.8,3.7,0.6l0,0 c0.4,0.9,0.3,1.9-0.4,2.6l-6.8,6.9c-1.5,1.6-3.7,2.4-5.9,2.4H21.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 21.2,48.1 22.3,46.4 11.7,36.5 2.7,47  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 9.4,
    y1: 39.2,
    x2: 17.6,
    y2: 47.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M39.7,11.3 c-2.5-0.3-5-2.2-6-3.1c-0.3-0.2-0.7-0.2-1,0c-1,0.9-3.5,2.8-6,3.1c-0.4,0.1-0.7,0.4-0.7,0.8c0.3,7.7,5.4,11.1,6.8,12 c0.2,0.1,0.5,0.1,0.7,0c1.4-0.8,6.5-4.2,6.8-12C40.4,11.7,40.1,11.3,39.7,11.3z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 0.9 30.1875 19.8069)",
    fontFamily: "'Prompt-Light'",
    fontSize: "10.8057px"
  }, "$")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 23.2,
    y1: 6,
    x2: 25.4,
    y2: 8.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 41.2,
    y1: 23.9,
    x2: 43.4,
    y2: 26.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 43.4,
    y1: 6,
    x2: 41.2,
    y2: 8.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 25.4,
    y1: 23.9,
    x2: 23.2,
    y2: 26.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 20.6,
    y1: 16,
    x2: 22.1,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 44.5,
    y1: 16,
    x2: 46.1,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 33.3,
    y1: 3.3,
    x2: 33.3,
    y2: 4.8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 33.3,
    y1: 27.2,
    x2: 33.3,
    y2: 28.8
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon9);
export default __webpack_public_path__ + "static/media/icon-9.660174a5f7436ea35735b7ac2d24158e.svg";
export { ForwardRef as ReactComponent };